export const API_GOOGLE_KEY = 'AIzaSyAR8yZRmavWm6sFeb_3Ily6Mwdow5p2wFM';
